<template>
  <div class="box2">
    <pageTitle
      title="商业变现模式明朗<br />短视频直播运营 持续赋能个人+企业"
      text="人生智慧，顺势而为，抓住AI视频电商与直播电商数字经济风口!"
      titleColor="#1A0400"
      titColor="#665552"
    />

    <div class="swiper-box">
      <swiper :options="swiperOption" ref="mySwiper" class="swiperitems">
        <swiper-slide
          class="swiperwrap"
          v-for="(item, index) in list"
          :key="index"
        >
          <div class="block">
            <div class="title">
              {{ item.title }}
              <p>{{ item.p }}</p>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>

    <div class="content-box">
      <swiper :options="contentSwiper" ref="contentSwiper">
        <swiper-slide
          class="swiper-slides"
          v-for="i in list[cur].itemist"
          :key="i + Math.random()"
        >
          <div class="block2">
            <div class="box" v-show="cur != 0"></div>
            <swiper v-if="i.arr" :options="contentSwiper3">
              <swiper-slide v-for="j in i.arr" :key="j + Math.random()">
                <img :src="j.img" alt />
              </swiper-slide>
            </swiper>

            <img v-else :src="i.img" alt />
            <div v-show="i.arr" class="swiper-pagination-box3"></div>
            <p>{{ i.txt1 }}</p>
            <p>{{ i.txt2 }}</p>
          </div>
        </swiper-slide>
      </swiper>
      <div
        class="swiper-pagination-box2"
        v-show="list[cur].itemist.length != 1"
      ></div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    cSwiper() {
      return this.$refs.contentSwiper.swiper;
    },
  },
  data() {
    let that = this;
    return {
      activeIndex: 0,
      swiperOption: {
        loop: true, // 循环模式选项
        slidesPerView: "auto",
        centeredSlides: true,
        // paginationClickable: true,
        spaceBetween: 10,
        // effect: "left",
        on: {
          slideChangeTransitionStart() {
            that.cur = this.realIndex;
          },
          click() {
            if (
              this.clickedIndex == 0 ||
              this.clickedIndex == 3 ||
              this.clickedIndex == 6
            ) {
              that.cur = 0;
            }
            if (
              this.clickedIndex == 1 ||
              this.clickedIndex == 4 ||
              this.clickedIndex == 7
            ) {
              that.cur = 1;
            }
            if (
              this.clickedIndex == 2 ||
              this.clickedIndex == 5 ||
              this.clickedIndex == 8
            ) {
              that.cur = 2;
            }
            if (this.clickedIndex == 0) {
              that.swiper.slidePrev();
            } else if (this.clickedIndex == 8) {
              that.swiper.slideNext();
            } else {
              that.swiper.slideTo(this.clickedIndex, 400, false);
            }
          },
        },
      },
      contentSwiper: {
        loop: false, // 循环模式选项
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 50,
        pagination: {
          el: ".swiper-pagination-box2",
        },
      },
      contentSwiper3: {
        loop: true, // 循环模式选项
        slidesPerView: "auto",
        centeredSlides: true,

        spaceBetween: 50,
        autoplay: {
          delay: 3000, // 自动播放的时长
          stopOnLastSlide: false /* 触摸滑动后是否继续轮播 */,
          disableOnInteraction: false,
        },

        pagination: {
          el: ".swiper-pagination-box3",
        },
      },
      cur: 0,
      list: [
        {
          title: "国家政策认可",
          p: "商业资本青睐",
          itemist: [
            {
              txt1: "截至2025年06月，中国短视频用户规模达10.68亿，用户使用率高达94.8%，用户即流量，AI+短视频电商、直播电商运营日益受到企业青睐",
              txt2: "数据来源：2025年数据来自CNNIC第56次报告（截至2025年6月）",
              img: require("../../../assets/coursePage/newMedia/box2/1.1.png"),
            },
            {
              txt1: "新媒体运营是时代发展与疫情影响下诞生的新职业，顺应社会需求。2020年国家人社部颁布的新职业中就有“全媒体运营师”，表明国家对该职业的认可",
              txt2: "",
              img: require("../../../assets/coursePage/newMedia/box2/1.2.png"),
            },
          ],
        },
        {
          title: "人才缺口大",
          p: "行业薪资高",
          itemist: [
            {
              txt1: "据职友集统计，全国新媒体相关岗位 152714 条",
              txt2: "",
              img: require("../../../assets/coursePage/newMedia/box2/2.1.png"),
            },

            {
              txt1: "全国新媒体相关岗位工资平均达 9444/月，一线城市薪资更高，上海可达 14922元/月",
              txt2: "数据来源：看*网",
              arr: [
                {
                  img: require("../../../assets/coursePage/newMedia/box2/2.2.png"),
                },
                {
                  img: require("../../../assets/coursePage/newMedia/box2/2.3.png"),
                },
              ],
            },
          ],
        },
        {
          title: "就业方向多",
          p: "晋升速度快",
          itemist: [
            {
              txt1: "AI视频创作与直播运营行业发展方向多，就业范围广，晋升就业更容易，有职场经验的同学，学完课就可能进入管理层",
              txt2: "",
              img: require("../../../assets/coursePage/newMedia/box2/3.1.png"),
            },
          ],
        },
      ],
    };
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.box2 {
  position: relative;
  padding: 80px 0px 78px;
  background: #fefbf3;
  width: 100%;

  overflow: hidden;

  .swiper-box {
    position: relative;
    margin-top: 18px;
    margin-bottom: 20px;
    /deep/ .swiper-slide {
      width: 352px;

      .block {
        transform: scale(0.9);
        transition: 0.5s all;
        margin-top: 30px;
        margin-bottom: 40px;
      }
    }

    .swiper-slide-active {
      .block {
        transform: scale(1);
        transition: 0.5s all;
        opacity: 1;
      }
    }

    .block {
      width: 352px;
      height: 161px;
      border: 5px solid #ffffff;
      background: linear-gradient(20deg, #ffd8ce 0%, #ffeae5 100%);
      box-shadow: 0px 8px 29px 0px rgba(255, 151, 127, 0.25);
      border-radius: 20px;

      text-align: center;
      opacity: 0.54;
      border-radius: 20px;
      box-sizing: border-box;

      .title {
        font-size: 30px;
        font-family: PingFang SC;
        font-weight: 600;
        color: #ec3e15;
        line-height: 52px;
        margin-top: 25px;
      }
    }
  }

  .content-box {
    margin-top: -60px;
    position: relative;

    .swiper-slides {
      width: 690px;
      padding-bottom: 48px;
      //height: 802px;
    }
  }
  .block2 {
    width: 686px;
    height: 676px;
    background: #ffffff;
    box-shadow: 0px 8px 48px 0px rgba(255, 126, 96, 0.24);
    border-radius: 20px;
    overflow: hidden;
    margin-top: 40px;
    text-align: center;
    position: relative;
    .box {
      height: 24px;
    }
    img {
      width: 638px;
      height: auto;
      margin: 24px auto 32px;
      display: block;
    }
    p:nth-child(4) {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #665552;
      line-height: 40px;
      padding: 0 40px;
      box-sizing: border-box;
    }
    p:nth-child(5) {
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #cbb3af;
      line-height: 32px;
      margin-top: 16px;
      padding: 0 40px;
      box-sizing: border-box;
    }
  }
  .swiper-pagination-box2 {
    display: flex;
    align-items: center;
    position: absolute;
    left: 50%;
    bottom: 10px;
    transform: translate(-50%, 0px);
    height: 6px;
    background: #ffab9a;
    border-radius: 3px;

    z-index: 99;
    /deep/ .swiper-pagination-bullet {
      width: 20px;
      height: 6px;
      background: #ffab9a;
      border-radius: 3px;
    }

    /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
      width: 20px;
      height: 6px;
      background: #ff5731;
      border-radius: 3px;
    }
  }

  .swiper-pagination-box3 {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 6px;
    margin-bottom: 32px;
    border-radius: 3px;
    position: absolute;
    top: 446px;
    right: 37px;
    z-index: 99;
    /deep/ .swiper-pagination-bullet {
      width: 16px;
      height: 6px;
      background: red;
      border-radius: 3px;
      margin-right: 4px;
      margin-left: 4px;
    }

    /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
      width: 16px;
      height: 6px;
      background: #ff5731;
      border-radius: 3px;
    }
  }
}
</style>
